import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppMenuitem } from './app.menuitem';

import { AuthService } from '../../auth/auth.service';

type MenuItemWithRoles = MenuItem & { roles?: string[]; separator?: boolean };

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule, AppMenuitem, RouterModule],
  template: `
    <ul class="layout-menu">
      <ng-container *ngFor="let item of model; let i = index">
        <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
        <li *ngIf="item.separator" class="menu-separator"></li>
      </ng-container>
    </ul>
  `,
})
export class AppMenu implements OnInit {
  model: MenuItem[] = [];

  constructor(private auth: AuthService) {}

  ngOnInit() {
    const userRoles = this.auth.getUserRoles();

    const fullMenu: MenuItemWithRoles[] = [
      {
        label: 'بازار همکاران طلا',
        items: [
          {
            label: 'داشبورد همکار',
            icon: 'pi pi-fw pi-home',
            routerLink: ['/'],
            roles: ['colleague', 'admin'],
          },
          {
            label: 'خرید/فروش طلا',
            icon: 'pi pi-fw pi-wallet',
            routerLink: ['/colleague'],
            roles: ['colleague'],
          },
        ],
      },
      {
        label: 'مدیریت همکاران',
        roles: ['admin'],
        items: [
          {
            label: 'لیست همکاران',
            icon: 'pi pi-fw pi-user-plus',
            routerLink: ['/colleagues'],
            roles: ['admin'],
          },
        ],
      },
    ];

    this.model = this.filterMenuByRoles(fullMenu, userRoles);
  }

  private filterMenuByRoles(items: MenuItemWithRoles[], userRoles: string[]): MenuItem[] {
    const hasAccess = (item: MenuItemWithRoles) => {
      if (!item.roles || item.roles.length === 0) return true;
      const required = item.roles.map((r) => r.toLowerCase());
      return required.some((role) => userRoles.includes(role));
    };

    return items
      .map((item) => {
        const copy: MenuItemWithRoles = { ...item };
        if (copy.items?.length) {
          copy.items = this.filterMenuByRoles(copy.items as MenuItemWithRoles[], userRoles) as any;
        }
        return copy;
      })
      .filter((item) => {
        if (!hasAccess(item)) return false;
        if (item.items && item.items.length === 0) return false;
        return true;
      }) as MenuItem[];
  }
}
